import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  if (!show) return null;
  return (
    <button
      data-testid="back-to-top-btn"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-brand-primary text-white shadow-xl hover:bg-brand-gold hover:text-brand-dark transition-all"
      aria-label="Back to top"
    >
      <i className="fa-solid fa-arrow-up" />
    </button>
  );
}
